import { TAssignDevicesCountOfItems, TAssignDevicesSortBy, TTypeOfModalWindow } from './devicesFormContext';
import { IRestaurantDevices, IAssignDevices } from 'types';

export enum AssignDevicesActionTypes {
	SET_RESTAURANT_DEVICES = 'SET_RESTAURANT_DEVICES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_SHOW_FREE_DEVICES = 'TOGGLE_SHOW_FREE_DEVICES',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_DATA_FOR_ASSIGN = 'SET_DATA_FOR_ASSIGN',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetRestaurantDevices {
	type: AssignDevicesActionTypes.SET_RESTAURANT_DEVICES;
	payload: {
		restaurantDevices: IRestaurantDevices;
	};
}

interface IChangeSearchString {
	type: AssignDevicesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface IToggleShowFreeDevices {
	type: AssignDevicesActionTypes.TOGGLE_SHOW_FREE_DEVICES;
}

interface ISetSortBy {
	type: AssignDevicesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: TAssignDevicesSortBy;
	};
}

interface ISetCountOfItems {
	type: AssignDevicesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: TAssignDevicesCountOfItems;
	};
}

interface IChangeCurrentPage {
	type: AssignDevicesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface ISetDataForAssign {
	type: AssignDevicesActionTypes.SET_DATA_FOR_ASSIGN;
	payload: {
		dataForAssign: IAssignDevices | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: AssignDevicesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TAssignDevicesAction =
	| ISetRestaurantDevices
	| IChangeSearchString
	| IToggleShowFreeDevices
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetDataForAssign
	| IChangeTypeOfModalWindow;
